<div class="container" *ngIf="isNoShown">
  <div class="container-wrapper" *ngIf="(isLoggedIn$ | async ) && !isPublic">
    <div class="row flexbox-container">
      <div>
        <a [carmRouterLink]="dashboardLink" class="carmPortalName"><h1>{{ 'portalName' | translate }}</h1></a>
      </div>
      <div *ngIf="showEnvironmentHeader" class='role-type-viewer' title="Only for test and debugging purpose.">
        <span *ngIf='!isSetupMyPortal'>{{(roleType$ | async | replaceUnderscore) | titlecase }}</span>
        <span *ngIf='isSetupMyPortal'>{{(firstNativeRole$ | async)}}</span><br>
        <span *ngIf='!isSetupMyPortal'>{{programType$ | async }}</span>
        <span *ngIf='isSetupMyPortal'>N/A (Native)</span><br>
        <span class='env'>{{env}}</span>
      </div>
      <div *ngIf="(publicHeaderService?.showProgramToggler | async) && (isShow$ | async)">
        <carm-main-header-program-menu-view></carm-main-header-program-menu-view>
      </div>
    </div>
  </div>
</div>
